<template>
  <div class="div_body">
    <!--左边导航栏-->
    <sidebar :modules="modules"></sidebar>
    <!--右边内容-->
    <div class="div_container">
      <header-common></header-common>
      <router-view></router-view>
    </div>
  </div>
</template>

<script>
  import HeaderCommon from '../components/header-common'
  import Sidebar from "../components/sidebar";
  export default {
    name: "home",
    components: {
      Sidebar,
      HeaderCommon
    },
    data: function(){
      return {
        modules: [
          {
            name: "货品管理",
            class: "icon_material",
            hasSubs: true,
            subs: [
              {
                name:"货品维护",
                pathName:"MaterialManage",
                subsPathName: ["MaterialManage","MaterialDetail","MaterialAdd"]
              },
              {
                name:"配方维护",
                pathName:"BomManage",
                subsPathName: ["BomManage","BomDetail"]
              },
              {
                name:"单位维护",
                pathName:"unit-manage",
                subsPathName: ["unit-manage"]
              },
              {
                name:"货品类别维护",
                pathName:"material-type-manage",
                subsPathName: ["material-type-manage"]
              },
            ]
          },
          {
            name:"供应商维护",
            class: "icon_supplier",
            hasSubs: false,
            pathName:"SupplierManage",
            subsPathName: ["SupplierManage","SupplierAdd","SupplierDetail"]
          },
          {
            name:"配送中心维护",
            class: "icon_dc",
            hasSubs: false,
            pathName:"DistributionCenter",
            subsPathName: ["DistributionCenter","DistributionCenterAdd","DistributionCenterDetail"]
          },
          {
            name:"门店维护",
            class: "icon_shop",
            hasSubs: false,
            pathName:"ShopManage",
            subsPathName: ["ShopManage","ShopAdd","ShopDetail"]
          },
          {
            name:"中央厨房维护",
            class: "icon_kitchen",
            hasSubs: false,
            pathName:"KitchenManage",
            subsPathName: ["KitchenManage","KitchenAdd","KitchenDetail"]
          },
          {
            name:"商户维护",
            class: "icon_merchant",
            hasSubs: false,
            pathName:"MerchantManage",
            subsPathName: ["MerchantManage","MerchantAdd","MerchantDetail"]
          },
          {
            name: "调价管理",
            class: "icon_price",
            hasSubs: true,
            subs: [
              {
                name:"采购调价处理",
                pathName:"PurchasePriceHandle",
                subsPathName: ["PurchasePriceHandle"]
              },
              {
                name:"采购调价查询",
                pathName:"PurchasePriceManage",
                subsPathName: ["PurchasePriceManage","PurchasePriceDetail"]
              },
              {
                name:"要货调价处理",
                pathName:"RequirePriceHandle",
                subsPathName: ["RequirePriceHandle"]
              },
              {
                name:"要货调价查询",
                pathName:"RequirePriceManage",
                subsPathName: ["RequirePriceManage","RequirePriceDetail"]
              },
              {
                name:"调拨调价处理",
                pathName:"AllotPriceHandle",
                subsPathName: ["AllotPriceHandle"]
              },
              {
                name:"调拨调价查询",
                pathName:"AllotPriceManage",
                subsPathName: ["AllotPriceManage","AllotPriceDetail"]
              },
              {
                name:"成本调价处理",
                pathName:"ProducePriceHandle",
                subsPathName: ["ProducePriceHandle"]
              },
              {
                name:"成本调价查询",
                pathName:"ProducePriceManage",
                subsPathName: ["ProducePriceManage","ProducePriceDetail"]
              },
            ]
          },
          {
            name:"权限管理",
            pathName:"RoleManage",
            class: "icon_role",
            hasSubs: false,
            subsPathName: ["RoleManage","RoleDetail"]
          },
          {
            name:"员工管理",
            pathName:"StaffManage",
            class: "icon_staff",
            hasSubs: false,
            subsPathName: ["StaffManage","StaffAdd","StaffDetail"]
          },
          {
            name:"品牌管理",
            pathName:"BrandManage",
            class: "icon_brand",
            hasSubs: false,
            subsPathName: ["BrandManage","BrandDetail"]
          },
          {
            name: "打印管理",
            class: "icon_print_manage",
            hasSubs: true,
            subs: [
              {
                name:"打印尺寸管理",
                pathName:"PrintManage",
                subsPathName: ["PrintManage"]
              },
            ]
          },
          {
            name:"日志管理",
            pathName:"LogManage",
            class: "icon_log",
            hasSubs: false,
            subsPathName: ["LogManage"]
          },
        ]
      }
    },
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/page/home.vue